module.exports = __webpack_public_path__ + "img/bg.93cc5f16.jpg";